import SearchLandingPage from '@/components/modules/Landing/SearchLandingPage';
import { searchLandingPages } from '@/content/searchLandingPages';

const ChatbaseComparisonPage = () => (
  <SearchLandingPage config={searchLandingPages.compareChatbase} />
);

export default ChatbaseComparisonPage;
